import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Post.css";

const Post = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const token = localStorage.getItem("access");
      const response = await fetch(
        "https://ambatturindustrialestate.com/api/api/posts/user/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (response.ok) {
        const data = await response.json();
        setPosts(data);
      } else {
        setMessage("Failed to fetch posts.");
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
      setMessage("An error occurred while fetching posts.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this post?")) {
      try {
        const token = localStorage.getItem("access");
        const response = await fetch(
          `https://ambatturindustrialestate.com/api/api/posts/${id}/`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        if (response.ok) {
          setMessage("Post deleted successfully!");
          // Remove the deleted post from the list
          setPosts(posts.filter((post) => post.id !== id));
        } else {
          setMessage("Failed to delete post.");
        }
      } catch (error) {
        console.error("Error deleting post:", error);
        setMessage("An error occurred while deleting the post.");
      }
    }
  };

  if (loading) {
    return (
      <div className="postlist-container container mt-4">
        <div className="postlist-loading d-flex justify-content-center">
          <div className="postlist-spinner spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="postlist-container container mt-4">
      <div className="postlist-header d-flex justify-content-between align-items-center mb-4">
        <h2 className="postlist-title">My Posts</h2>
        <Link to="/posts/create" className="postlist-btn postlist-btn-primary">
          <i className="bi bi-plus-circle me-2"></i>Add New Post
        </Link>
      </div>

      {message && (
        <div
          className={`postlist-alert alert ${
            message.includes("successfully") ? "alert-success" : "alert-danger"
          } alert-dismissible fade show`}
        >
          {message}
          <button
            type="button"
            className="btn-close"
            onClick={() => setMessage("")}
          ></button>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="postlist-empty card">
          <div className="postlist-empty-body card-body text-center py-5">
            <h5 className="postlist-empty-title card-title">No posts found</h5>
            <p className="postlist-empty-text card-text">
              You haven't created any posts yet.
            </p>
            <Link
              to="/posts/create"
              className="postlist-btn postlist-btn-primary"
            >
              Create Your First Post
            </Link>
          </div>
        </div>
      ) : (
        <div className="postlist-grid row">
          {posts.map((post) => (
            <div key={post.id} className="postlist-item col-md-6 col-lg-4 mb-4">
              <div className="postlist-card card h-100">
                <img
                  src={post.image || "/assets/placeholder.png"}
                  className="postlist-card-img card-img-top"
                  alt={post.title || "Dummy Image"}
                />
                <div className="postlist-card-body card-body">
                  <h5 className="postlist-card-title card-title">
                    {post.title}
                  </h5>
                  <p className="postlist-card-text card-text">
                    {post.description.length > 100
                      ? `${post.description.substring(0, 100)}...`
                      : post.description}
                  </p>
                  {post.quantity && (
                    <p className="postlist-card-quantity card-text">
                      <small className="text-muted">
                        Quantity: {post.quantity}
                      </small>
                    </p>
                  )}
                </div>
                {/* <div className="postlist-card-footer card-footer bg-transparent">
                  <div className="postlist-card-actions d-flex justify-content-between">
                    <Link
                      to={`/posts/edit/${post.id}`}
                      className="postlist-btn postlist-btn-outline postlist-btn-sm"
                    >
                      Edit
                    </Link>
                    <button
                      onClick={() => handleDelete(post.id)}
                      className="postlist-btn postlist-btn-danger postlist-btn-sm"
                    >
                      Delete
                    </button>
                  </div>
                </div> */}

                <div className="postlist-card-footer card-footer bg-transparent">
                  <div className="postlist-card-actions d-flex flex-column gap-2">
                    <Link
                      to={`/posts/enquiries?postId=${post.id}`}
                      className="postlist-btn postlist-btn-info postlist-btn-sm w-100"
                    >
                      <i className="bi bi-envelope me-2"></i>View Enquiries
                    </Link>
                    <div className="d-flex justify-content-between">
                      <Link
                        to={`/posts/edit/${post.id}`}
                        className="postlist-btn postlist-btn-outline postlist-btn-sm"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() => handleDelete(post.id)}
                        className="postlist-btn postlist-btn-danger postlist-btn-sm"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Post;
